try{self['workbox:navigation-preload:4.1.1']&&_()}catch(e){}// eslint-disable-line